import repository from "./repository";
import resources from "./resources";
import urlTemplate from "@/shared/url-template";

export default {
  markAllAsRead: async () =>
    (await repository.instance.post(resources.markAllAsRead)).data,
  markAsRead: async (ids) => (await repository.instance.post(resources.markAsRead, ids)).data,
  getAll: async (page, pageSize) => (await repository.instance.get(urlTemplate(resources.getAll, {
    page,
    pageSize
  }))).data,
  get: async (id) => (await repository.instance.get(urlTemplate(resources.get, {id}))).data
}
